Shopware.Component.register('sw-cms-block-custom-form', () => import('./component'));
Shopware.Component.register('swag-cms-extensions-preview-custom-form', () => import('./preview'));

Shopware.Service('cmsService').registerCmsBlock({
    name: 'custom-form',
    label: 'swag-cms-extensions.sw-cms.elements.custom-form.label',
    category: 'form',
    component: 'sw-cms-block-custom-form',
    previewComponent: 'swag-cms-extensions-preview-custom-form',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: '20px',
        marginRight: '20px',
        sizingMode: 'boxed',
    },
    slots: {
        content: {
            type: 'custom-form',
        },
    },
});
